module.exports = __webpack_public_path__ + "static/media/08.c1a29c42.jpg";